import React from 'react';
import Button from './Button/Button';
import './selectedPopup.css';

const SelectedLeadPopup = ({ selectedItem, activityLogs, closePopup, handleEditClick }) => {
  return (
    <div className="popup">
      <div className="popup-content">
        <div className="popup-header">
          <Button onClick={closePopup} className="close-btn top-right" title="Close">×</Button>
        </div>
        <div className="popup-body">
          <div className="popup-grid">
            {/* Details Section */}
            <div className="details-section">
              <h4>Lead Details</h4>
              <p><strong>Lead ID:</strong> {selectedItem.lead_id}</p>
              <p><strong>Posted On:</strong> {new Date(selectedItem.posted_on).toLocaleDateString()}</p>
              <p><strong>Status:</strong> {selectedItem.responded}</p>
            </div>

            {/* Contact Information */}
            <div className="contact-info-section">
              <h4>Contact Information</h4>
              <p><strong>Name:</strong> {selectedItem.contact_name || selectedItem.name}</p>
              <p><strong>Phone No:</strong> {selectedItem.contact_phone || selectedItem.phone}</p>
              <p><strong>Email:</strong> {selectedItem.contact_email || selectedItem.email}</p>
            </div>

            {/* Technical Information */}
            <div className="technical-info-section">
              <h4>Technical Information</h4>
              <p><strong>Product:</strong> {selectedItem.product_name}</p>
              <p><strong>Specification:</strong> {selectedItem.specifications}</p>
              {selectedItem.qty && <p><strong>Qty:</strong> {selectedItem.qty}</p>}
              <p><strong>Location:</strong> {selectedItem.delivery_location}</p>
            </div>

            {/* Response Notes */}
            <div className="response-notes-section">
              <h4>Response Notes</h4>
              {selectedItem.response_notes && selectedItem.response_notes.trim() !== '' ? (
                <p>{selectedItem.response_notes}</p>
              ) : (
                <p>No response notes available.</p>
              )}
            </div>

            {/* Activity Logs */}
            <div className="activity-logs-section">
              <h4>Activity Logs</h4>
              {activityLogs.length > 0 ? (
                <ul>
                  {activityLogs.map((log, index) => (
                    <li key={index}>
                      <strong>{new Date(log.created_at).toLocaleString()}:</strong> {log.activity_type} - {log.description}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No activity logs available.</p>
              )}
            </div>
          </div>

          <Button
            className="lead-edit-btn"
            onClick={() => {
              handleEditClick(selectedItem);
              closePopup();
            }}
            title="Edit"
          >
            Edit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SelectedLeadPopup;
